import AssignedStopRow from './component';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const journeyFields = ['shipper_orders_skin', 'status'];
const stopFields = ['shipper_order_id', 'shipper_order_ids', 'isCancelled', 'store'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { shipper_orders_skin, status } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      journeyFields
    );
    const { shipper_order_id, shipper_order_ids, isCancelled, store } =
      props.selectors.getJourneyStopFields(state, props.journeyId, props.stopId, stopFields);
    return {
      skin: shipper_orders_skin[shipper_order_id],
      isAggregated: (shipper_order_ids || []).length > 1,
      isPartiallyCancelled: isCancelled && status !== 'CANCELLED',
      store,
    };
  }),
  withProps(({ numberOfStops }) => ({
    showLoadInfo: numberOfStops > 2,
  }))
);

export default enhance(AssignedStopRow);
